import { render, staticRenderFns } from "./studentMessageDetail.vue?vue&type=template&id=a155ec68&scoped=true"
import script from "./studentMessageDetail.vue?vue&type=script&lang=js"
export * from "./studentMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./studentMessageDetail.vue?vue&type=style&index=0&id=a155ec68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a155ec68",
  null
  
)

export default component.exports